<div class="platform-page-container">
  <div class="platform-header-container">
    <markant-platform-registration-header
      [isLogoutPage]="true"
      [loginButton]="true"
    ></markant-platform-registration-header>
  </div>

  <div class="platform-main">
    <div class="platform-content-container">
      <div class="platform-content">
        <h2>{{ 'auth.logoutSuccessful' | transloco }}</h2>

        <div class="flex-centered">
          <markant-button
            colorScheme="primary"
            (click)="login()"
            (keydown.enter)="login()"
          >
            <markant-icon
              icon="m_login"
              class="login-icon"
              slot="icon-leading"
            ></markant-icon>
            {{ 'auth.backToLandingPage' | transloco }}
          </markant-button>
        </div>
      </div>

      <div class="platform-footer">
        <markant-platform-footer [isPublic]="true"></markant-platform-footer>
      </div>
    </div>
  </div>
</div>
